import { render, staticRenderFns } from "./leadMinor.vue?vue&type=template&id=7102292a&scoped=true&"
import script from "./leadMinor.vue?vue&type=script&lang=js&"
export * from "./leadMinor.vue?vue&type=script&lang=js&"
import style0 from "./leadMinor.vue?vue&type=style&index=0&id=7102292a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7102292a",
  null
  
)

export default component.exports